module.exports = __webpack_public_path__ + "static/media/pic5@2x.9e2c3757.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic5@2x.png
// module id = 1398
// module chunks = 0